import { render, staticRenderFns } from "./ConversationCell.vue?vue&type=template&id=afc4d49a&scoped=true"
import script from "./ConversationCell.vue?vue&type=script&lang=js"
export * from "./ConversationCell.vue?vue&type=script&lang=js"
import style0 from "./ConversationCell.vue?vue&type=style&index=0&id=afc4d49a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc4d49a",
  null
  
)

export default component.exports